/**
 * Gating widoczności integracji Google Ads (VP-192).
 *
 * Aplikacja nie przeszła weryfikacji Google OAuth — poza listą testerów w Google
 * Cloud Console każde podłączenie kończy się ekranem „Dostęp zablokowany"
 * (403 access_denied). Integracja jest więc niegotowa i znika z UI dla zwykłych
 * userów; zostaje widoczna dla `super_admin`, żeby dało się ją testować od środka
 * (ten sam wzorzec co YouTube/LinkedIn Content Publish w centrum integracji).
 *
 * Jedno źródło prawdy dla wszystkich miejsc, które pokazują Google Ads
 * (centrum integracji, ustawienia analityki, panel w czacie, przewodnik,
 * rekomendacje, wybory źródła danych) — wzorzec z `shopify-access.ts`.
 *
 * Po przejściu weryfikacji Google: usuń wywołania tego helpera (albo zmień go na
 * `true`), integracja wraca bez odtwarzania kodu.
 */

export type GoogleAdsAccessUser = {
  role?: string | null;
};

/** Czy user ma widzieć w UI cokolwiek związanego z integracją Google Ads. */
export function canAccessGoogleAdsIntegration(
  user: GoogleAdsAccessUser | null | undefined
): boolean {
  return user?.role === "super_admin";
}
